// extracted by mini-css-extract-plugin
module.exports = {"basic-message":"basic-message-e73260b759bcdd36377a2cde31401d86"};